import { UI_ACTION_TYPES } from './actionTypes';

export const CONSUMER_KEY = 'ck_cc0a022a5d3947aa6a7999949e630e7ce84a3943';
export const CONSUMER_SECRET = 'cs_398d29cc68089b9aba16d452224b5880c6cb8a8a';

export const openSearch = () => ({ type: UI_ACTION_TYPES.SEARCH_OPEN });
export const closeSearch = () => ({ type: UI_ACTION_TYPES.SEARCH_CLOSE });
export const openAuth = () => ({ type: UI_ACTION_TYPES.AUTH_OPEN });
export const closeAuth = () => ({ type: UI_ACTION_TYPES.AUTH_CLOSE });
export const openMenu = () => ({ type: UI_ACTION_TYPES.MENU_OPEN });
export const closeMenu = () => ({ type: UI_ACTION_TYPES.MENU_CLOSE });
export const setFormChanged = () => ({ type: UI_ACTION_TYPES.SET_FORM_CHANGED });
export const resetFormChanged = () => ({ type: UI_ACTION_TYPES.RESET_FORM_CHANGED });
export const setCountry = (country) => ({ type: UI_ACTION_TYPES.SET_COUNTRY, country });
export const setRegion = (region) => ({ type: UI_ACTION_TYPES.SET_REGION, region });

export const sendEmail = (data) => {
    let url =
        'https://stage.e-feed.ru/wp-json/app/v1/create-ticket/?' +
        Object.keys(data)
            .map((k) => k + '=' + encodeURIComponent(data[k]))
            .join('&');

    return fetch(url, { method: 'post' })
        .then((response) => response.json())
        .then((json) => {
            if (json.status !== 200) {
                console.warn(' error while put ticket', url, data, json);
            }
        })
        .catch((ex) => {
            console.error('Ошибка запроса: ' + String(ex));
        });
};
